export default (value, _locale, choicePattern) => {
    let val = String(value);
    if (!choicePattern) {
        return val;
    }
    // {0,choice,0#none|1#one|1<many}
    const regPattern = /^([0-9]+)([#<]+)(.*)$/;
    const parts = choicePattern.split("|");
    for (let i = parts.length - 1; i >= 0; i--) {
        const match = parts[i].match(regPattern);
        if (match === null || match?.length < 3) {
            return val;
        }
        const v = parseInt(match[1]);
        const operator = match[2];
        const str = match[3];
        if ((operator === "#" && value <= v) || (operator === "<" && value > v) || (i === 0 && !val)) {
            val = str;
        }
    }
    return val;
};
